import { instance4 } from "App/constants";
import {
  defaultDateInputDisplay,
  formatNumber,
  oneMonthBeforeToday,
  today,
} from "App/utils/helpers";
import { getPembelianById } from "../Pembelian/helpers";

export const RESET_STATE_FORM_FILTER = {
  id:"",
  id_pembelian:"",
  supplier_id:"",
  supplier:"Pilih Supplier",
  no_faktur:"",
  tipe_pembayaran_id: "",
  kas_id: null,
  kas_name: "Pilih Kas",
  tanggal_awal: oneMonthBeforeToday(),
  tanggal_akhir: today(),
  pages: 1,
  limit: 10,
};

export const getPembayaranAll = async (formFilter, pages, limit) => {
  try {
    const api = await instance4.post(`/wmsAsset/pembayaran/list`, {
      id:formFilter.id,
      pembelian_id:formFilter.id_pembelian,
      supplier_id:formFilter.supplier_id,
      faktur_no:formFilter.no_faktur,
      tipe_pembayaran_id: formFilter.tipe_pembayaran_id,
      kas_id: formFilter.kas_id,
      halaman: pages,
      jumlah: limit,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.totalData),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error.response.data.message,
    };
  }
};

export const getNotifReqFA = async ({ id }) => {
  const api = await getPembayaranAll({ id: id }, 1, 1);
  if (api.state) {
    const response = await getPembelianById(id);
    const _tempTotal = response.data;
    const rowsData = api.data[0];
    const dataProps = {
      tanggal_masuk: defaultDateInputDisplay(rowsData.tanggal_masuk, true),
      tipe_pembayaran_id: rowsData.tipe_pembayaran_id,
      kas_id: rowsData.kas_id,
      kas_name: rowsData.kas_name,
      jumlah_bayar2: formatNumber(rowsData.jumlah_bayar),
      pembelian_id: rowsData.pembelian_id,

      total_pembelian: _tempTotal,
    };
    return dataProps;
  } else {
    return null;
  }
};
